import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/platform-guide', label: '分类' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-heading font-semibold text-foreground-950 whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
              <i className="ri-sun-line text-background-50 text-lg"></i>
            </span>
            {siteInfo.name}
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#"
              className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即体验
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileOpen && (
          <div className="md:hidden py-4 border-t border-background-200/70">
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors duration-200 cursor-pointer ${
                    location.pathname === link.path
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="#"
                className="mt-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                立即体验
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}